module.exports = __webpack_public_path__ + "media/images/wendys-bg-f8cf278e22e16b3722495480ffa2a62d.png";